import {
  IResourceComponentsProps,
  useNavigation,
  useShow,
  useTable,
  useCan,
  useGetIdentity,
  useMany,
  useList,
  useUpdate,
  useDelete,
} from '@pankod/refine-core'
import { useEffect, useState } from 'react'
import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  CloneButton,
  ShowButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  TagField,
  Progress,
  Menu,
  Typography,
  Button,
  message,
  Popconfirm,
} from '@pankod/refine-antd'
import type { DeleteButtonProps } from '@pankod/refine-antd'
import 'styles/custom.css'
import { TableColumnsType, Tag } from 'antd'
import { IUser, IWorkRequest, IWorkRequestReviewer } from 'interfaces'
// import { CreateWorkRequest } from "./create";
// import { EditWorkRequest } from "./edit";
import { CloneWorkRequest } from 'pages/workrequests/clone'
import { CreateWorkRequest } from 'pages/workrequests'
import { EditWorkRequest } from 'pages/workrequests'
import { QuestionFilter } from 'components/filters/questionFilter'
import { MoreFilter } from 'components/filters/moreFilters'
import Permissions from 'permissions'
import wrMetadata from 'metadata/workrequests'
// import reviewerMetadata from "metadata/reviewers"

import { PaginationProps } from 'antd'
import { getWorkRequestByConditions } from 'gql/query'
import { EditWorkRequesFromPaper } from './editWorkRequestFromPaper'
import { EditPaperWorkRequest } from './editWrFromPaper'
const { PlusOutlined, AppstoreOutlined, CopyOutlined, DeleteOutlined } = Icons
const { Text, Link } = Typography
type Permission = {
  granted?: boolean
}

type WorkRequestsFromPaperTableProps = {
  paperId: string
}

export const WorkRequestsFromPaperTable: React.FC<WorkRequestsFromPaperTableProps> = ({ paperId }) => {
  const { data: user } = useGetIdentity()

  // const [filterType, setFilterType] = useState('all');
  const { filters, setFilters, tableQueryResult, sorter, current, setCurrent, pageCount, setPageSize } = useTable<IWorkRequest>({
    resource: 'work_requests',
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'active',
        operator: 'eq',
        value: 'true',
      },
      {
        field: 'paper_id',
        operator: 'eq',
        value: paperId,
      },
    ],
    metaData: wrMetadata,
    queryOptions: { staleTime: Infinity },
  })

  const { mutate: workRequestInactive } = useUpdate<IWorkRequest>()

  const { queryResult, setShowId } = useShow<IWorkRequest>({
    resource: 'work_requests',
    metaData: wrMetadata,
  })

  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data

  // const currentPermission=Permissions.getGrants().map()

  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close: editClose,
  } = useModalForm({
    resource: 'work_requests',
    action: 'edit',
    metaData: wrMetadata,
    redirect: false,
  })

  const renderApproveCount = (work_request: any) => {
    let approved_count = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'Published') approved_count++
      })
    return approved_count.toFixed(0)
  }
  const renderReviewCount = (work_request: any) => {
    let review_count = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'For Approval' || element?.status === 'Published') review_count++
      })
    return review_count.toFixed(0)
  }
  const renderRejectedAtReview = (record: any) => {
    let rejected_review_count = 0
    record?.questions?.length > 0 &&
      record?.questions?.map((element: any) => {
        if (element?.status === 'Rejected at Review' || element?.status === 'For Review (Require Amending)') rejected_review_count++
      })
    return rejected_review_count.toFixed(0)
  }

  const columns: TableColumnsType<IWorkRequest> = [
    {
      dataIndex: 'request_id',
      title: 'Id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (_, record) => (
        <>
          <Text
            style={{
              width: 200,
              textAlign: 'left',
              // color: '#6659FF',
            }}
            ellipsis={{ tooltip: record?.name }}
          >
            {record?.name}
          </Text>
        </>
      ),
    },
    {
      dataIndex: 'paper_wr_type',
      title: 'Paper WR Type',
      render(value, record, index) {
        return <Tag color={value === 'Normal' ? 'blue' : 'purple'}>{value}</Tag>
      },
    },
    {
      dataIndex: 'request_type',
      title: 'Type',
    },
    {
      dataIndex: 'question_type_id',
      title: 'Q Type',
    },
    // {
    //   dataIndex: 'grade_id',
    //   title: 'Grade',
    //   render: (_, record) => record?.grade?.name,
    // },
    {
      dataIndex: 'subject_id',
      title: 'Subject',
      render: (_, record) => (
        <Text style={{ width: 70, textAlign: 'left' }} ellipsis={{ tooltip: record?.subject?.name }}>
          {record?.subject?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'status',
      title: 'Stage',
      // width: 100,
      className: 'ant-table-column-sort',
      render: value => (
        <Tag
          color={
            value === 'Completed'
              ? 'green'
              : value === 'Draft'
              ? 'pink'
              : value === 'Closed'
              ? 'volcano'
              : value === 'Bulk Request' || value === 'Urgent Request'
              ? 'pink'
              : 'geekblue'
          }
        >
          {value}
        </Tag>
      ),
    },
    {
      dataIndex: 'due_date',
      title: 'Due Date',
      render: value => <DateField format="DD-MMM-YY" value={value} />,
    },
    {
      dataIndex: 'completion_status',
      title: 'Status',
      // width: 100,
      className: 'ant-table-column-sort',
      render: (_, record) => <Progress percent={Math.floor(record?.completion_status)} type="line" />,
    },

    {
      dataIndex: 'count',
      title: 'T',
    },
    {
      dataIndex: 'create_count',
      title: 'C',
      render: (_, record) => record?.questions?.length - parseInt(renderRejectedAtReview(record)),
    },
    {
      dataIndex: 'review_count',
      title: 'R',
      render: (_, record) => <>{parseInt(renderReviewCount(record))}</>,
    },
    {
      dataIndex: 'approve_count',
      title: 'A',
      render: (_, record) => <>{renderApproveCount(record)}</>,
    },

    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) => (
        <Space>
          <EditButton
            key="wrfp_edit"
            // size="small"
            type="link"
            hideText
            title="Edit"
            recordItemId={record.id}
            disabled={
              (record?.paper_wr_type !== 'Normal' && record?.paper_wr_type !== 'Urgent') || (record?.status !== 'Open' && record?.status !== 'Draft')
            }
            onClick={() => {
              setShowId(record.id)
              editShow(record.id)
            }}
          />
          <Popconfirm
            key="wrfp"
            title="Are you sure to delete this task?"
            onConfirm={(e: any) => workRequestInactive({ id: record?.id, resource: 'work_requests', values: { active: false } })}
            okText="Yes"
            cancelText="No"
            disabled={['In Progress', 'Closed'].includes(record?.status)}
          >
            <Button
              size="small"
              type="link"
              style={{ color: 'red' }}
              disabled={['In Progress', 'Closed'].includes(record?.status)}
              // icon={<Icons.DeleteOutlined />}
            >
              <Icons.DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ]

  return (
    <List
      title={<h5 style={{ margin: '0' }}>Associated Work Requests</h5>}
      pageHeaderProps={
        {
          // extra: [<RefreshButton key="refresh" onClick={() => refreshData()} />],
        }
      }
    >
      <>
        <Table style={{ overflow:'scroll' }} size="small" columns={columns} dataSource={tableQueryResult?.data?.data} pagination={false} loading={tableQueryResult?.isLoading} />
      </>
      <EditPaperWorkRequest close={editClose} modalProps={editModalProps} formProps={editFormProps} record={record} refreshData />
      {/* <EditWorkRequesFromPaper close={editClose} modalProps={editModalProps} formProps={editFormProps} record={record!} /> */}
    </List>
  )
}
